module.exports = __webpack_public_path__ + "static/media/alink.703398a7.svg";